<template>
  <div>
    <el-card shadow="hover">
      <template v-if="!embedded" slot="header">
        <div class="clearfix">
          <span>提货申请</span>
          <span class="muted small" style="margin-left:10px">仅展示小程序业务员 礼品 / 产品试用 / 新出库 / 送存货 的提交记录</span>
          <div style="float: right">
            <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
            <el-button type="primary" size="small" @click="openEdit(null)">新建</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item v-if="!embedded" label="客户姓名">
          <el-input v-model="searchForm.customerName" placeholder="请输入" style="width: 160px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchForm.outboundType" placeholder="全部" clearable style="width: 130px" @change="handleSearch">
            <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.status" placeholder="全部" clearable style="width: 150px" @change="handleSearch">
            <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item v-if="embedded" class="embed-actions">
          <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
          <el-button type="primary" size="small" @click="openEdit(null)">新建</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="orderList" stripe size="small" border @row-dblclick="onRowDblclick">
        <el-table-column type="expand" width="40" :fixed="embedded ? false : 'left'">
          <template slot-scope="props">
            <div class="detail-panel">
              <div class="detail-panel-title"><i class="el-icon-info"></i><span>订单详情</span></div>
              <div class="detail-card-row" :class="{ 'dbl-edit': props.row.status === 0 || props.row.status === 2 }" @dblclick="(props.row.status === 0 || props.row.status === 2) && openEdit(props.row)" :title="(props.row.status === 0 || props.row.status === 2) ? '双击任意位置修改' : ''">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">订单ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">申请单号</span><span class="dc-value">{{ props.row.applicationNo || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户姓名</span><span class="dc-value">{{ props.row.customerName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">类型</span>
                    <el-tag :type="typeTag(props.row.outboundType)" size="mini">{{ outTypeLabel(props.row) }}</el-tag>
                  </div>
                  <div class="dc-cell w4"><span class="dc-label">产品内容</span><span class="dc-value">{{ props.row.productNames || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">申请时间</span><span class="dc-value">{{ (props.row.outboundDate ? (props.row.outboundType === '尊贵卡A' ? String(props.row.outboundDate).slice(0, 10) : String(props.row.outboundDate).slice(0, 16)) : '') || formatDate(props.row.createTime, 10) || '-' }} <el-tag v-if="isHistoryReplenishment(props.row)" type="warning" size="mini" style="margin-left:4px;">历史补录</el-tag></span></div>
                  <div class="dc-cell"><span class="dc-label">总实付金额</span><span class="dc-value strong">¥{{ Number(props.row.totalAmount || 0).toFixed(2) }}</span></div>
                  <div class="dc-cell"><span class="dc-label">欠款</span>
                    <span class="dc-value" :class="{ warn: Number(props.row.debt || 0) > 0 }">¥{{ Number(props.row.debt || 0).toFixed(2) }}</span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">订单状态</span>
                    <el-tag :type="statusTag(props.row.outboundType, props.row.status)" size="mini">{{ statusLabel(props.row.outboundType, props.row.status) }}</el-tag>
                  </div>
                  <div class="dc-cell"><span class="dc-label">审核员</span><span class="dc-value">{{ props.row.approverName || '-' }}</span></div>
                  <div class="dc-cell w4" :class="{ highlight: isHistoryReplenishment(props.row) }">
                    <span class="dc-label">申请备注</span>
                    <span class="dc-value" :class="{ 'highlight-value': isHistoryReplenishment(props.row) }">
                      <template v-if="isHistoryReplenishment(props.row)">
                        <span>⚠️ 历史补录：{{ historyReplenishmentRemarkNote(props.row) || props.row.remark }}</span>
                        <span v-if="props.row.remark && historyReplenishmentRemarkNote(props.row) && props.row.remark !== historyReplenishmentRemarkNote(props.row)" style="margin-left:8px;color:#873800;font-weight:normal;">（手填备注：{{ props.row.remark }}）</span>
                      </template>
                      <template v-else>
                        {{ props.row.remark || '-' }}
                      </template>
                    </span>
                  </div>
                  <div class="dc-cell w4"><span class="dc-label">驳回原因</span><span class="dc-value" :style="props.row.rejectRemark ? 'color:#f56c6c' : ''">{{ props.row.rejectRemark || '-' }}</span></div>
                </div>
              </div>

              <!-- 明细 -->
              <div class="detail-panel-title" style="margin-top: 14px;">
                <i class="el-icon-document"></i>
                <span>订单明细 · 共 {{ (props.row.details || []).length }} 项</span>
              </div>
              <div v-if="!(props.row.details || []).length" class="muted small">无明细</div>
              <div v-else class="detail-grid" :class="{ 'dbl-edit': props.row.status === 0 || props.row.status === 2 }" @dblclick="(props.row.status === 0 || props.row.status === 2) && openEdit(props.row)" :title="(props.row.status === 0 || props.row.status === 2) ? '双击任意位置修改' : ''">
                <div v-for="(d, i) in props.row.details" :key="i" class="detail-card-row">
                  <div class="detail-card-head">
                    <span class="dc-no">#{{ i + 1 }}</span>
                    <span class="dc-name">{{ d.productName || '—' }}</span>
                  </div>
                  <div class="detail-card-body">
                    <div class="dc-cell"><span class="dc-label">单价</span><span class="dc-value">¥{{ d.price != null ? Number(d.price).toFixed(2) : 0 }}</span></div>
                    <div class="dc-cell"><span class="dc-label">本次提货</span><span class="dc-value">{{ d.quantity || 0 }}</span></div>
                    <div class="dc-cell"><span class="dc-label">实付</span><span class="dc-value strong">¥{{ d.actualAmount != null ? Number(d.actualAmount).toFixed(2) : 0 }}</span></div>
                    <template v-if="props.row.outboundType === '送存货'">
                      <div class="dc-cell"><span class="dc-label">总存货数量</span><span class="dc-value">{{ d.stockQuantity != null ? d.stockQuantity : 0 }}</span></div>
                      <div class="dc-cell"><span class="dc-label">剩余存货</span><span class="dc-value">{{ d.remainingStock != null ? d.remainingStock : 0 }}</span></div>
                    </template>
                  </div>
                </div>
              </div>

              <!-- 高拍仪扫描横向（礼品/试用 不显示） -->
              <div v-if="props.row.outboundType !== '礼品' && props.row.outboundType !== '试用'" class="sig-row">
                <div class="sig-block">
                  <div class="section-title">现场拍照</div>
                  <div v-if="props.row.images" class="img-list">
                    <el-image v-for="(url, i) in (props.row.images || '').split(',').filter(Boolean)"
                              :key="i" :src="full(url)" :preview-src-list="(props.row.images || '').split(',').filter(Boolean).map(full)"
                              style="width:60px;height:60px;border-radius:4px;margin:0 4px 4px 0"></el-image>
                  </div>
                  <div v-else class="muted small">未上传</div>
                </div>
                <div class="sig-block">
                  <div class="section-title">客户签署</div>
                  <div v-if="props.row.customerSignature">
                    <el-image :src="full(props.row.customerSignature)" :preview-src-list="[full(props.row.customerSignature)]" style="width:140px;height:80px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                  </div>
                  <div v-else class="muted small">未签署</div>
                </div>
                <div class="sig-block">
                  <div class="section-title">员工签署</div>
                  <div v-if="props.row.employeeSignature">
                    <el-image :src="full(props.row.employeeSignature)" :preview-src-list="[full(props.row.employeeSignature)]" style="width:140px;height:80px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                  </div>
                  <div v-else class="muted small">未签署</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="订单ID" width="80"></el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="s">
            <el-tag :type="typeTag(s.row.outboundType)" size="small">{{ outTypeLabel(s.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户姓名" width="110"></el-table-column>
        <el-table-column prop="productNames" label="产品内容" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="总实付金额" width="120">
          <template slot-scope="s">¥{{ Number(s.row.totalAmount || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="销售日期" width="160">
          <template slot-scope="s">{{ formatDate(s.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="欠款" width="110">
          <template slot-scope="s">
            <span :class="{ warn: Number(s.row.debt || 0) > 0 }">¥{{ Number(s.row.debt || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" min-width="220">
          <template slot-scope="s">
            <el-dropdown v-if="s.row.outboundType === '新出库' && (s.row.status === 3 || s.row.status === 4)" trigger="click" @command="(v) => changeStatus(s.row, v)">
              <el-tag :type="statusTag(s.row.outboundType, s.row.status)" size="small" style="cursor:pointer">
                {{ statusLabel(s.row.outboundType, s.row.status) }} <i class="el-icon-arrow-down el-icon--right"></i>
              </el-tag>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="3" :disabled="s.row.status === 3">已完结</el-dropdown-item>
                <el-dropdown-item :command="4" :disabled="s.row.status === 4">未完结</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tag v-else :type="statusTag(s.row.outboundType, s.row.status)" size="small">
              {{ statusLabel(s.row.outboundType, s.row.status) }}
            </el-tag>
            <span v-if="s.row.status === 2 && s.row.rejectRemark" style="margin-left:6px;color:#f56c6c;font-size:12px;" :title="s.row.rejectRemark">原因：{{ s.row.rejectRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="申请备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="180" :fixed="embedded ? false : 'right'" align="center">
          <template slot-scope="s">
            <el-button size="mini" type="primary" v-if="s.row.status === 0 || s.row.status === 2" @click="openEdit(s.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新建/修改弹窗 -->
      <el-dialog :title="form.id ? '修改订单' : '新建订单'" :visible.sync="editVisible" width="780px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="form" label-width="100px" size="small">
          <el-row :gutter="16">
            <el-col :span="form.outboundType === '送存货' ? 8 : 12"><el-form-item label="客户姓名" required>
              <el-input v-model="form.customerName" :placeholder="form.outboundType === '送存货' ? '需为已存在客户' : '请输入'" :disabled="embedded && !form.id" @blur="loadCustomerSalesCategories"></el-input>
            </el-form-item></el-col>
            <el-col :span="form.outboundType === '送存货' ? 8 : 12"><el-form-item label="类型" required>
              <el-select v-model="form.outboundType" placeholder="先选择类型" style="width:100%">
                <el-option v-for="opt in dialogTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
              </el-select>
            </el-form-item></el-col>
            <el-col v-if="form.outboundType === '送存货'" :span="8"><el-form-item label="存货类型" required>
              <el-select v-model="form.stockType" placeholder="选择存货类型" style="width:100%" @change="onStockTypeChange">
                <el-option label="普通存货" value="普通存货"></el-option>
                <el-option label="品鉴存货" value="品鉴存货"></el-option>
              </el-select>
            </el-form-item></el-col>
          </el-row>
          <el-form-item label="申请备注">
            <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入"></el-input>
          </el-form-item>

          <el-divider content-position="left">{{ form.outboundType === '礼品' ? '礼品明细' : '产品明细' }}</el-divider>
          <div v-if="!form.outboundType || !form.customerName" class="muted small" style="margin-bottom:8px">请先选择类型并输入客户姓名</div>
          <div v-for="(d, idx) in form.details" :key="idx" class="detail-card">
            <el-row :gutter="16" align="middle">
              <el-col :span="12">
                <el-select v-model="d.productId" filterable :placeholder="dialogProductPlaceholder" style="width:100%" :disabled="!form.outboundType || !form.customerName || productOpts.length === 0" @change="onDetailProductChange(d)">
                  <el-option v-for="p in productOpts" :key="p.id" :label="p.name" :value="p.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-input-number v-model="d.quantity" :min="1" controls-position="right" style="width:100%" placeholder="数量"></el-input-number>
              </el-col>
              <el-col :span="4">
                <el-button v-if="form.details.length > 1" size="mini" type="text" icon="el-icon-delete" @click="form.details.splice(idx, 1)">删除</el-button>
              </el-col>
            </el-row>
          </div>
          <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="form.details.push({ productId: null, productName: '', quantity: 1 })">添加产品</el-button>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="editVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitEdit" :loading="submitting">保存</el-button>
        </div>
      </el-dialog>

      <!-- 变更记录抽屉 -->
      <el-drawer title="变更记录" :visible.sync="changeLogVisible" size="540px" direction="rtl">
        <div style="padding: 0 20px 24px">
          <el-timeline v-if="changeLogs.length">
            <el-timeline-item v-for="log in changeLogs" :key="log.id" :timestamp="formatDate(log.changeTime)" placement="top">
              <el-card shadow="hover">
                <div><strong>{{ log.fieldName }}</strong> 变更</div>
                <div class="muted small" style="margin-top:4px">操作人：{{ log.operator || '-' }}</div>
                <div class="muted small" style="margin-top:6px">原值：{{ log.oldValue || '-' }}</div>
                <div class="muted small" style="margin-top:4px">新值：{{ log.newValue || '-' }}</div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <el-empty v-else description="暂无变更记录"></el-empty>
        </div>
      </el-drawer>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; loadList() }"
          @current-change="p => { currentPage = p; loadList() }"
          :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NormalOrder',
  props: {
    embeddedCustomer: { type: Object, default: null }
  },
  data() {
    return {
      searchForm: { customerName: '', outboundType: '', status: '' },
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      typeOptions: ['礼品', '试用', '送存货', '新出库'],
      // 弹窗"类型"下拉动态项：该客户销售订单 category 集合（送存货/尊贵卡A/B/C 等）
      customerSalesCategories: [],
      productOpts: [],
      editVisible: false,
      submitting: false,
      form: this.emptyForm(),
      changeLogVisible: false,
      changeLogs: [],
      statusOptions: [
        { value: 0, label: '审核中' },
        { value: 2, label: '已驳回' },
        { value: 1, label: '待签字' },
        { value: 5, label: '已签字（待出库）' },
        { value: 4, label: '未完结' },
        { value: 3, label: '已完结' }
      ]
    }
  },
  mounted() { this.loadList() },
  computed: {
    embedded() { return !!(this.embeddedCustomer && this.embeddedCustomer.id) },
    dialogProductPlaceholder() {
      if (!this.form.outboundType) return '请先选择类型'
      if (!this.form.customerName) return '请先填写客户姓名'
      if (this.productOpts.length === 0) {
        return this.form.outboundType === '送存货' ? '该客户名下暂无可送存的产品' : '加载中…'
      }
      return this.form.outboundType === '礼品' ? '选择礼品' : '选择产品'
    },
    // 弹窗"类型"下拉：永久 礼品/产品试用/新出库 + 该客户销售订单出现过的 category（去重）。
    // 展示文案"产品试用"对应后端 outboundType="试用"
    dialogTypeOptions() {
      const base = [
        { label: '礼品', value: '礼品' },
        { label: '产品试用', value: '试用' },
        { label: '新出库', value: '新出库' }
      ]
      const baseValues = new Set(base.map(b => b.value))
      const extra = (this.customerSalesCategories || [])
        .filter(c => c && !baseValues.has(c))
        .map(c => ({ label: c, value: c }))
      return [...base, ...extra]
    }
  },
  watch: {
    'form.outboundType'() { this.refreshProductOpts() },
    'form.customerName'() {
      this.refreshProductOpts()
      this.loadCustomerSalesCategories()
    }
  },
  methods: {
    getCardWindowStartStr(card) {
      if (!card) return null
      const startDateStr = card.serviceFeeStartDate || card.createTime
      if (!startDateStr) return null
      const feeDateStr = String(startDateStr).slice(0, 10)
      const parts = feeDateStr.split('-')
      if (parts.length < 3) return null
      const startMonth = parseInt(parts[1], 10)
      const startDay = parseInt(parts[2], 10)
      const today = new Date()
      const currYear = today.getFullYear()
      let winStartYear = currYear
      const candidateDate = new Date(currYear, startMonth - 1, startDay)
      if (today < candidateDate) {
        winStartYear = currYear - 1
      }
      const pad = n => String(n).padStart(2, '0')
      return `${winStartYear}-${pad(startMonth)}-${pad(startDay)}`
    },
    isHistoryReplenishment(row) {
      if (!row || !['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(row.outboundType)) return false
      if (row.isHistoryReplenishment === true) return true
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      if (!appTime) return false
      const appStr = String(appTime).replace('T', ' ')
      const winStartStr = this.getCardWindowStartStr(row)
      if (winStartStr && appStr.slice(0, 10) < winStartStr) return true
      if (actualTime && row.outboundType !== '尊贵卡A' && appStr < String(actualTime).replace('T', ' ')) return true
      return false
    },
    historyReplenishmentRemarkNote(row) {
      if (!row || !this.isHistoryReplenishment(row)) return ''
      const cardName = String(row.cardName || row.outboundType || '').trim()
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      const isCardA = cardName.toUpperCase().includes('A')
      const winStartStr = this.getCardWindowStartStr(row)
      const appStr = String(appTime || '').replace('T', ' ')

      if (isCardA) {
        const applyFmt = String(appTime || '').slice(0, 10)
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的剩余可领取数量。`
      }
      const applyFmt = String(appTime || '').replace('T', ' ').slice(0, 16)
      if (actualTime && !isCardA && appStr <= String(actualTime).replace('T', ' ')) {
        const actualFmt = String(actualTime).replace('T', ' ').slice(0, 16)
        const wordUnit = cardName.toUpperCase().includes('B') ? '应该剩余额度' : '应该剩余'
        return `申请时间（${applyFmt}）早于实际剩余设置时间（${actualFmt}），属于本年度历史补录。保存后【只扣除${wordUnit}】，【不扣除实际剩余】。`
      }
      if (winStartStr && appStr.slice(0, 10) < winStartStr) {
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
      }
      return `申请时间（${applyFmt}）属于过去的服务年度，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
    },
    // 拉该客户销售订单出现过的 category，加到弹窗"类型"下拉
    loadCustomerSalesCategories() {
      const name = (this.form.customerName || '').trim()
      if (!name) { this.customerSalesCategories = []; return }
      const params = { page: 1, size: 100, type: 'normal', customerName: name }
      if (this.embedded && this.embeddedCustomer && this.embeddedCustomer.id) {
        params.customerId = this.embeddedCustomer.id
      }
      axios.get('/order/page', { params }).then(res => {
        const records = (res.data && res.data.records) || []
        const set = new Set()
        records.forEach(o => { if (o.category) set.add(o.category) })
        this.customerSalesCategories = [...set]
      }).catch(() => { this.customerSalesCategories = [] })
    },
    loadList() {
      const params = { page: this.currentPage, size: this.pageSize }
      // 嵌入模式：锁定该客户，仍可叠加类型/状态搜索
      if (this.embedded) params.customerId = this.embeddedCustomer.id
      if (!this.embedded && this.searchForm.customerName) params.customerName = this.searchForm.customerName
      if (this.searchForm.outboundType) params.outboundType = this.searchForm.outboundType
      if (this.searchForm.status !== '' && this.searchForm.status !== null) params.status = this.searchForm.status
      axios.get('/outbound/normal-page', { params }).then(res => {
        this.orderList = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      })
    },
    handleSearch() { this.currentPage = 1; this.loadList() },
    resetSearch() { this.searchForm = { customerName: '', outboundType: '', status: '' }; this.handleSearch() },
    refreshProductOpts() {
      const type = this.form.outboundType
      const name = (this.form.customerName || '').trim()
      if (!type || !name) {
        this.productOpts = []
        return
      }
      if (type === '送存货') {
        const stType = this.form.stockType || '普通存货'
        // 找客户 id → 调 customerInventory 拿该客户名下送存货可提货产品
        axios.get('/customer/list').then(res => {
          const list = res.data || []
          const hit = list.find(c => c.name === name)
          if (!hit) { this.productOpts = []; return }
          axios.get('/customer/' + hit.id + '/inventory', { params: { outboundType: '送存货', stockType: stType } }).then(r => {
            const items = (r.data && r.data.items) || []
            this.productOpts = items.map(it => ({ id: it.productId, name: it.productName }))
            this.form.details.forEach(d => {
              if (d.productId && !this.productOpts.find(p => p.id === d.productId)) {
                d.productId = null; d.productName = ''
              }
            })
          })
        })
      } else if (type === '礼品') {
        axios.get('/gift/list').then(res => {
          this.productOpts = res.data || []
        })
      } else if (['尊贵卡A','尊贵卡C'].includes(type)) {
        // 尊贵卡A/C：该客户该卡订单已购产品，加"尊贵卡-"前缀
        axios.get('/customer/list').then(res => {
          const list = res.data || []
          const hit = list.find(c => c.name === name)
          if (!hit) { this.productOpts = []; return }
          axios.get('/customer/' + hit.id + '/inventory', { params: { outboundType: type } }).then(r => {
            const items = (r.data && r.data.items) || []
            this.productOpts = items.map(it => ({ id: it.productId, name: String(it.productName || '').startsWith('尊贵卡-') ? it.productName : ('尊贵卡-' + it.productName) }))
          })
        })
      } else if (type === '尊贵卡B') {
        // 尊贵卡B：公司所有产品（按额度扣），加"尊贵卡-"前缀
        axios.get('/product/list').then(res => {
          this.productOpts = (res.data || []).map(p => ({ id: p.id, name: String(p.name || '').startsWith('尊贵卡-') ? p.name : ('尊贵卡-' + p.name) }))
        })
      } else {
        // 试用 / 新出库：拉非礼品产品
        axios.get('/product/list').then(res => {
          this.productOpts = res.data || []
        })
      }
    },
    onStockTypeChange() {
      this.form.details = [{ productId: null, productName: '', quantity: 1 }]
      this.refreshProductOpts()
    },
    emptyForm() {
      return {
        id: null, _origStatus: null, customerId: null, customerName: '',
        outboundType: '', stockType: '普通存货', reason: '', remark: '',
        details: [{ productId: null, productName: '', quantity: 1 }]
      }
    },
    onRowDblclick(row) {
      // 仅 status=0(待审批) 或 status=2(已驳回) 时双击可修改;其它状态不响应
      if (row && (row.status === 0 || row.status === 2)) this.openEdit(row)
    },
    openEdit(row) {
      if (!row) {
        this.form = this.emptyForm()
        // 嵌入模式：新建锁定为当前客户
        if (this.embedded) {
          const c = this.embeddedCustomer || {}
          this.form.customerId = c.id
          this.form.customerName = c.name || ''
        }
        this.editVisible = true
        return
      }
      if (row.status !== 0 && row.status !== 2) {
        this.$message.warning('仅审核中或已驳回状态下可以修改')
        return
      }
      this.form = {
        id: row.id, _origStatus: row.status,
        customerId: row.customerId,
        customerName: row.customerName || '',
        outboundType: row.outboundType || '',
        stockType: row.stockType || (row.outboundType === '送存货' ? '普通存货' : ''),
        reason: row.reason || '',
        remark: row.remark || '',
        details: (row.details || []).map(d => ({
          productId: d.productId, productName: d.productName, quantity: d.quantity
        }))
      }
      if (this.form.details.length === 0) this.form.details.push({ productId: null, productName: '', quantity: 1 })
      this.editVisible = true
    },
    onDetailProductChange(d) {
      const p = (this.productOpts || []).find(x => x.id === d.productId)
      if (p) d.productName = p.name
    },
    submitEdit() {
      const name = (this.form.customerName || '').trim()
      if (!name) { this.$message.warning('请输入客户姓名'); return }
      if (!this.form.outboundType) { this.$message.warning('请选择类型'); return }
      if (!this.form.details.length || this.form.details.some(d => !d.productId || !(Number(d.quantity) > 0))) {
        this.$message.warning('请完善产品明细'); return
      }
      this.submitting = true
      const wasRejected = this.form._origStatus === 2
      if (this.form.id) {
        const body = {
          customerId: this.form.customerId,
          outboundType: this.form.outboundType,
          stockType: this.form.outboundType === '送存货' ? (this.form.stockType || '普通存货') : null,
          reason: this.form.reason,
          remark: this.form.remark,
          details: this.form.details.map(d => ({
            productId: d.productId, productName: d.productName, quantity: Number(d.quantity) || 0
          }))
        }
        axios.put('/outbound/' + this.form.id, body).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(wasRejected ? '修改成功，已重新进入审核' : '修改成功')
            this.editVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '修改失败')
          }
        }).finally(() => { this.submitting = false })
      } else {
        // 新建：送存货必须找到已存在客户 + 校验该客户在销售订单中有"送存货"档案；其它类型找不到则自动新建
        const isStock = this.form.outboundType === '送存货'
        axios.get('/customer/list').then(res => {
          const list = res.data || []
          const hit = list.find(c => c.name === name)
          if (hit) return hit.id
          if (isStock) {
            return Promise.reject(new Error('客户不存在，请先到客户管理新建'))
          }
          return axios.post('/customer', { name, contactPhone: '' }).then(() =>
            axios.get('/customer/list').then(r => {
              const list2 = r.data || []
              const fresh = list2.find(c => c.name === name)
              return fresh ? fresh.id : null
            }))
        }).then(customerId => {
          if (!isStock) return customerId
          // 送存货：校验该客户是否有 category='送存货' 的销售订单档案
          return axios.get('/order/page', { params: { page: 1, size: 1, customerName: name, type: 'normal', category: '送存货' } })
            .then(r2 => {
              const records = (r2.data && r2.data.records) || []
              if (!records.length) {
                return Promise.reject(new Error('该客户没有送存货的销售订单档案'))
              }
              return customerId
            })
        }).then(customerId => {
          const me = JSON.parse(sessionStorage.getItem('user') || '{}')
          const body = {
            customerId, userId: me.id || null,
            outboundType: this.form.outboundType,
            stockType: this.form.outboundType === '送存货' ? (this.form.stockType || '普通存货') : null,
            reason: this.form.reason,
            remark: this.form.remark,
            skipApproval: true,
            details: this.form.details.map(d => ({
              productId: d.productId, productName: d.productName, quantity: Number(d.quantity) || 0
            }))
          }
          return axios.post('/outbound/submit', body)
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('新建成功')
            // 超管放行的免期/休眠会带 warning，弹个长一点的提示
            if (res.data.warning) {
              this.$message({ message: res.data.warning, type: 'warning', duration: 6000 })
            }
            this.editVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '新建失败')
          }
        }).catch(err => {
          if (err && err.message) this.$message.error(err.message)
        }).finally(() => { this.submitting = false })
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该订单？该操作不可撤销', '提示', { type: 'warning' }).then(() => {
        axios.delete('/outbound/' + row.id).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败')
          }
        })
      }).catch(() => {})
    },
    openChangeLog(row) {
      axios.get('/outbound/' + row.id + '/change-log').then(res => {
        this.changeLogs = res.data || []
        this.changeLogVisible = true
      })
    },
    statusOptionsFor(type) {
      // 礼品/试用：去掉 1（已通过/未签字）和 4（未完结）
      // 送存货：去掉 4（未完结）
      // 新出库：保留全部
      if (type === '礼品' || type === '试用') {
        return this.statusOptions.filter(o => o.value !== 1 && o.value !== 4)
      }
      if (type === '送存货') {
        return this.statusOptions.filter(o => o.value !== 4)
      }
      return this.statusOptions
    },
    changeStatus(row, newStatus) {
      if (newStatus === row.status) return
      axios.post('/outbound/' + row.id + '/status', { status: newStatus }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('状态已更新')
          this.loadList()
        } else {
          this.$message.error((res.data && res.data.message) || '修改失败')
        }
      })
    },
    handleDispatch(row) {
      this.$confirm('确认出库该订单？将扣减库存并写入出库记录', '提示', { type: 'warning' }).then(() => {
        axios.post('/outbound/' + row.id + '/dispatch').then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已出库')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '出库失败')
          }
        })
      }).catch(() => {})
    },
    // 状态文案随类型变化（礼品/试用不签字，无 1/5；新出库特殊 4 显示"未完结"）
    statusLabel(type, s) {
      const isGiftOrTrial = type === '礼品' || type === '试用'
      const m = {
        0: '审核中',
        1: isGiftOrTrial ? '待出库' : '待签字',
        2: '已驳回',
        3: '已完结',
        4: '未完结',
        5: isGiftOrTrial ? '待出库' : '已签字（待出库）'
      }
      return m[s] != null ? m[s] : s
    },
    statusTag(type, s) {
      const m = { 0: 'warning', 1: 'primary', 2: 'danger', 3: 'success', 4: 'info', 5: 'warning' }
      return m[s] || ''
    },
    typeTag(t) {
      if (t === '礼品') return 'warning'
      if (t === '试用') return 'success'
      if (t === '送存货' || t === '普通存货' || t === '品鉴存货' || t === '试用存货') return 'warning'
      if (t === '新出库') return 'danger'
      return ''
    },
    outTypeLabel(row) {
      if (!row) return '-'
      const t = row.outboundType
      if (t === '送存货') {
        if (row.stockType === '品鉴存货' || row.stockType === '试用存货' || row.applicableTypeName) {
          return (row.applicableTypeName && String(row.applicableTypeName).trim())
            ? ('品鉴存货·' + String(row.applicableTypeName).trim())
            : (row.stockType || '品鉴存货')
        }
        return row.stockType || '普通存货'
      }
      if (t === '试用' || t === '产品试用') {
        const at = row.applicableTypeName && String(row.applicableTypeName).trim()
        return at ? (at.includes('试用') ? at : at + '试用') : '试用'
      }
      if (t === '礼品') {
        const at = row.applicableTypeName && String(row.applicableTypeName).trim()
        return at ? (at.includes('礼品') ? at : at + '礼品') : '礼品'
      }
      return t || '-'
    },
    formatDate(v, len) { return v ? String(v).replace('T', ' ').slice(0, len || 19) : '' },
    full(url) {
      if (!url) return ''
      if (/^(https?:|data:)/i.test(url)) return url
      const base = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return base + url
    },
    exportCsv() {
      const cols = ['订单ID', '类型', '客户姓名', '产品内容', '总实付金额', '销售日期', '欠款', '订单状态', '备注']
      const rows = this.orderList.map(o => [
        o.id, this.outTypeLabel(o), o.customerName || '', o.productNames || '',
        Number(o.totalAmount || 0).toFixed(2), this.formatDate(o.createTime),
        Number(o.debt || 0).toFixed(2), this.statusLabel(o.outboundType, o.status), o.remark || ''
      ].map(v => v == null ? '' : String(v).replace(/,/g, '，')))
      const csv = '\uFEFF' + [cols.join(','), ...rows.map(r => r.join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '提货申请_' + new Date().toISOString().slice(0, 10) + '.csv'
      link.click()
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; text-align: right; }
.muted { color: #909399; }
.small { font-size: 12px; }
.warn { color: #f56c6c; font-weight: 600; }
.section-title { margin: 12px 0 8px; font-size: 13px; font-weight: 600; color: #303133; }

.detail-panel { padding: 14px 24px 18px; background: linear-gradient(180deg,#fafcff 0%,#f5f7fa 100%); border-top: 1px dashed #dcdfe6; }
.detail-panel-title { display: flex; align-items: center; gap: 6px; color: #303133; font-size: 13px; font-weight: 600; margin: 4px 0 12px; }
.detail-panel-title i { color: #409eff; }
.detail-grid { display: flex; flex-direction: column; gap: 10px; }
.detail-card-row { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); padding: 12px 14px; margin-bottom: 12px; }
.dbl-edit { cursor: pointer; transition: background .15s; }
.dbl-edit:hover { background: #f0f7ff; }
.detail-card-head { display: flex; align-items: center; gap: 14px; padding-bottom: 8px; margin-bottom: 8px; border-bottom: 1px dashed #ebeef5; }
.dc-no { color: #fff; background: #409eff; padding: 2px 8px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.dc-name { color: #303133; font-weight: 600; font-size: 14px; }
.detail-card-body { display: grid; grid-template-columns: repeat(8, 1fr); gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.dc-cell.w4 { grid-column: span 4; }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.dc-value.strong { color: #67c23a; font-weight: 600; }

.img-list { display: flex; flex-wrap: wrap; }
.sig-row { display: flex; gap: 10px; margin-top: 12px; flex-wrap: wrap; }
.sig-block { flex: 0 0 auto; min-width: 160px; max-width: 220px; background: #fafcff; border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; }
.sig-block .section-title { margin-top: 0; font-size: 12px; }
.detail-card { background: #f8f9fb; padding: 8px 12px; border-radius: 4px; margin-bottom: 8px; }
</style>
